import { render } from "./DrawAddressToast.vue?vue&type=template&id=dd1814dc&scoped=true&bindings={}"
import script from "./DrawAddressToast.vue?vue&type=script&lang=ts"
export * from "./DrawAddressToast.vue?vue&type=script&lang=ts"

import "./DrawAddressToast.vue?vue&type=style&index=0&id=dd1814dc&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-dd1814dc"

export default script